export default {
  name: 'myDetectorsName',

  lookup(options) {
    return 'en';
  },

  cacheUserLanguage(lng, options) {
  }
};